// ACTION TYPES
const name = 'params';
export const actionTypes = {
  SET_SAMPLE_PARAM: `${name}:set_sample_param`,
};

// ACTIONS
export function setSampleParam(param) {
  return (dispatch) => {
    dispatch({ type: actionTypes.SET_SAMPLE_PARAM, value: param });
  };
}
